import React from "react";
import { useHistory } from "react-router-dom";
import TextField from "@mui/material/TextField";
import CircularProgress from "@mui/material/CircularProgress";
import { Formik } from "formik";
import { Grid, Typography, Card } from "@mui/material";
import Button from "@mui/material/Button";
import Swal from "sweetalert2";
import api from "../../../components/services/api";
import withReactContent from "sweetalert2-react-content";
import { makeStyles } from "@mui/styles";
const useStyles = makeStyles({
  customOutline: {
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "red",
    },
  },
});
export default function AddTransshipment() {
  const history = useHistory();
  const EmpId = localStorage.getItem("EmpId");
  const classes = useStyles();

  return (
    <div>
      <Card variant="outlined" style={{ padding: "20px", margin: "25px" }}>
        <h6 style={{ marginTop: "10px" }} className="textcolorgreen">
          เพิ่มการขนส่ง
        </h6>

        <Grid container alignItems="center" spacing={1}>
          <Grid item xs>
            <Typography
              className="textcolordarkblue"
              variant="h5"
              component="h1"
            >
              Transshipment
            </Typography>
          </Grid>
          <Grid item sx={{ display: "flex", flexDirection: "row" }}>
            <Typography className="textcolorBule">Setting</Typography>
            <Typography>
              <span>&nbsp;</span> / Transshipment
            </Typography>
          </Grid>
        </Grid>

        <Formik
          initialValues={{ transshipment_name: "", transshipment_no: "" }}
          validate={(values) => {
            const errors = {};
            if (
              !values.transshipment_name ||
              values.transshipment_name === ""
            ) {
              errors.transshipment_name = " * Required";
            }
            if (!values.transshipment_no || values.transshipment_no === "") {
              errors.transshipment_no = " * Required";
            }
            return errors;
          }}
          onSubmit={(values, { setSubmitting }) => {
            setTimeout(() => {
              const data = {
                no: values.transshipment_name,
                name: values.transshipment_no,
                status: 1,
                createId: EmpId,
              };

              api
                .post("api/transshipment/create", data)
                .then((respose) => {
                  const MySwal = withReactContent(Swal);

                  MySwal.fire({
                    icon: "success",
                    didOpen: () => {
                      MySwal.clickConfirm();
                    },
                  }).then(() => {
                    return MySwal.fire(
                      "สำเร็จ!",
                      "เพิ่มข้อมูลข้อมูลการขนส่งสำเร็จ !",
                      "success"
                    ).then((result) => {
                      if (result.isConfirmed) {
                        history.push("/Setting/Transshipment");
                      }
                    });
                  });
                })
                .catch((err) => {
                  console.log(err);
                });

              setSubmitting(false);
            }, 400);
          }}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            isSubmitting,
            /* and other goodies */
          }) => (
            <form onSubmit={handleSubmit} style={{ margin: "20px" }}>
              <h6 style={{ marginTop: "10px" }} className="textcolordarkblue">
              การขนส่ง
              </h6>
              <Grid container>
                <Grid item xs={4} sm={4} md>
                  <br />
                  <TextField
                    label="TRANSSHIPMENT  NO."
                    InputLabelProps={{ shrink: true }}
                    placeholder="Enter TRANSSHIPMENT  NO."
                    name="transshipment_no"
                    style={{
                      width: "50%",
                    }}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.transshipment_no}
                    required
                    classes={{ root: !values.transshipment_no ? classes.customOutline : null }}

                  />
                  {/* {errors.transshipment_no &&
                    touched.transshipment_no &&
                    errors.transshipment_no} */}
                  <br />
                  <TextField
                    name="transshipment_name"
                    label="TRANSSHIPMENT NAME"
                    variant="outlined"
                    placeholder="TRANSSHIPMENT NAME"
                    style={{
                      width: "50%",
                      marginTop: "10px",
                      marginBottom: "10px",
                    }}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    InputLabelProps={{ shrink: true }}
                    value={values.transshipment_name}
                    required
                    classes={{ root: !values.transshipment_name ? classes.customOutline : null }}

                  />
                  {errors.transshipment_name &&
                    touched.transshipment_name &&
                    errors.transshipment_name}
                </Grid>
              </Grid>
              <Button
                type="button"
                variant="outlined"
                style={{
                  color: "#80c340",
                  borderColor: "#80c340",
                  marginRight: "10px",
                }}
                onClick={history.goBack}
              >
                back
              </Button>
              <Button
                type="submit"
                variant="contained"
                style={{
                  background: "#80c340",
                  borderColor: "#80c340",
                  marginRight: "10px",
                }}
                disabled={isSubmitting}
              >
                {isSubmitting && <CircularProgress size={22} />}
                {!isSubmitting && "SAVE"}
              </Button>
            </form>
          )}
        </Formik>
      </Card>
    </div>
  );
}
